import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db, storage } from '../../services/firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const EditBook = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [book, setBook] = useState(null);
  const [loading, setLoading] = useState(true);
  const [image, setImage] = useState(null);

  useEffect(() => {
    const fetchBook = async () => {
      const docSnap = await getDoc(doc(db, "books", id));
      if (docSnap.exists()) {
        setBook({ id: docSnap.id, ...docSnap.data() });
      }
      setLoading(false);
    };
    fetchBook();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let imageUrl = book.imageUrl;
      if (image) {
        const imageRef = ref(storage, `books/${Date.now()}_${image.name}`);
        await uploadBytes(imageRef, image);
        imageUrl = await getDownloadURL(imageRef);
      }

      await updateDoc(doc(db, "books", id), {
        title: book.title,
        author: book.author,
        price: parseFloat(book.price),
        description: book.description,
        genre: book.genre,
        pages: parseInt(book.pages),
        imageUrl
      });

      alert("Book updated!");
      navigate('/admin/books');
    } catch (error) {
      alert("Error: " + error.message);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!book) return <p>Book not found</p>;

  return (
    <div>
      <h1>Edit Book</h1>
      <form onSubmit={handleSubmit}>
        <input type="text" value={book.title} onChange={(e) => setBook({ ...book, title: e.target.value })} required />
        <input type="text" value={book.author} onChange={(e) => setBook({ ...book, author: e.target.value })} required />
        <input type="number" step="0.01" value={book.price} onChange={(e) => setBook({ ...book, price: e.target.value })} required />
        <textarea value={book.description} onChange={(e) => setBook({ ...book, description: e.target.value })} rows="5" />
        <input type="text" value={book.genre} onChange={(e) => setBook({ ...book, genre: e.target.value })} />
        <input type="number" value={book.pages} onChange={(e) => setBook({ ...book, pages: e.target.value })} />
        <p>Current Image:</p>
        <img src={book.imageUrl} alt="current" style={{ width: '200px' }} />
        <input type="file" accept="image/*" onChange={(e) => setImage(e.target.files[0])} />
        <button type="submit" className="button">Update Book</button>
      </form>
    </div>
  );
};

export default EditBook;